import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const TickIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 20 18" {...props}>
      <path d="M0 8.99167L1.70833 7.40833C3.65366 8.33293 5.50173 9.44958 7.225 10.7417C10.6761 6.58019 14.8066 3.03287 19.4417 0.25L20 1.53333C15.7167 5.26667 12.5833 9.43333 8.06667 17.5333C5.57986 14.5018 2.88442 11.6477 0 8.99167Z" />
    </SvgIcon>
  );
});
